/**
 * Was die Betreiber selbst gemeldet haben.
 *
 * Steht auf der Übersicht, weil es dorthin gehört: eine Beanstandung vom
 * Bauhof ist der häufigste Anlass, kurzfristig auf einen Platz zu fahren –
 * häufiger als ein Termin aus der Fälligkeit.
 *
 * Ausdrücklich kein Knopf, der daraus einen Mangel macht. Ein Mangel ist
 * eine Feststellung des Prüfers. Entstünde er hier, ohne dass jemand
 * hingesehen hat, stünde in den Unterlagen eine Feststellung, die niemand
 * gemacht hat. „Zur Kenntnis" nimmt die Meldung vom Tisch, mehr nicht –
 * und der Betreiber sieht in seinem Portal, dass sie angekommen ist.
 */

import { Link } from 'react-router-dom'
import {
  KONTROLLARTTEXT,
  useKontrollgaenge,
  useKontrollgangGesehen,
} from '../api/eigenkontrollen'
import { Fehlerhinweis, datumDeutsch } from './Hinweise'

export function Kontrollmeldungen() {
  const gaenge = useKontrollgaenge(true)
  const gesehen = useKontrollgangGesehen()

  const liste = gaenge.data ?? []
  // Kein Platzhalter, wenn nichts da ist: die Übersicht soll nicht mit
  // leeren Abschnitten zuwachsen.
  if (liste.length === 0) return null

  return (
    <section>
      <h2 className="ueberschrift-akzent mb-3 text-xl">
        Meldungen der Betreiber ({liste.length})
      </h2>
      <p className="mb-3 text-base text-slate-700">
        Bei eigenen Kontrollen aufgefallen. Was daraus folgt, entscheiden Sie.
      </p>

      <Fehlerhinweis fehler={gesehen.error} />

      <ul className="space-y-2">
        {liste.map((g) => (
          <li key={g.id} className="karte border-stufe-2">
            <div className="flex flex-wrap items-start gap-3">
              <div className="min-w-0 flex-1">
                <div className="font-semibold">
                  <Link
                    to={`/spielplaetze/${g.spielplatz_id}`}
                    className="text-marke-700 underline"
                  >
                    {g.spielplatz_name}
                  </Link>{' '}
                  · {g.kunde_name}
                </div>
                <div className="text-base text-slate-700">
                  {KONTROLLARTTEXT[g.art]} am {datumDeutsch(g.datum)} durch{' '}
                  {g.durchgefuehrt_von}
                </div>
              </div>
              <button
                type="button"
                className="knopf-still px-3 text-base"
                disabled={gesehen.isPending}
                onClick={() => gesehen.mutate(g.id)}
              >
                Zur Kenntnis
              </button>
            </div>

            <ul className="mt-2 space-y-1">
              {g.beanstandungen.map((b, i) => (
                <li key={i} className="rounded-feld bg-stufe-2-grund p-2">
                  <span className="font-semibold">{b.bezeichnung}:</span>{' '}
                  {b.befund}
                  {/* Die Bilder sind der Grund, warum sich aus einer Meldung
                      entscheiden lässt, ob es eilt – ohne sie bliebe nur
                      hinfahren. */}
                  {b.foto_ids.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-2">
                      {b.foto_ids.map((id) => (
                        <a
                          key={id}
                          href={`/api/eigenkontrollen/fotos/${id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={`/api/eigenkontrollen/fotos/${id}`}
                            alt={`Foto zu ${b.bezeichnung}`}
                            className="h-24 w-32 rounded border-2 border-slate-200 object-cover"
                            loading="lazy"
                          />
                        </a>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>

            {g.bemerkung && (
              <p className="mt-2 text-base text-slate-700">{g.bemerkung}</p>
            )}
          </li>
        ))}
      </ul>
    </section>
  )
}
